import { createActionConst } from '../../../utils/action.utils';

const MEETING_INFO_NAMESPACE = 'MEETING_INFO';

export const STORE_MEETING_INFO = createActionConst(MEETING_INFO_NAMESPACE, 'STORE_MEETING_INFO');
export const CLEAR_MEETING_INFO = createActionConst(MEETING_INFO_NAMESPACE, 'CLEAR_MEETING_INFO');
